/*
  Окно «Проживающий» (20.10.2026): внести строку домовой книги или поправить её.

  Графы - те же, что у бланка выписки из домовой книги и у сверенного скана: домовая
  книга - копия бланка целиком (решение владельца 01.10.2026). Строка, внесённая или
  исправленная человеком, получает источник «человек», и очередной обмен с 1С её не
  стирает - сервер ставит это сам.

  Пустое поле при правке отправляется как `null`: очистить ошибочно внесённое значение
  можно, а ФИО и признак регистрации остаются обязательными.
*/

import { useState } from 'react'

import { api } from '../../api/client.js'
import { Field, Switch } from '../Common.jsx'
import FormDialog from './FormDialog.jsx'

const TEXT_FIELDS = ['relation', 'purpose', 'birth_place', 'citizenship', 'arrived_from', 'left_to']
const DATE_FIELDS = ['birth_date', 'arrived_on', 'left_on']

const REGISTERED = [
  { value: true, title: 'Зарегистрирован' },
  { value: false, title: 'Только проживает' },
]

function startForm(resident) {
  const form = { full_name: resident?.full_name ?? '', is_registered: resident?.is_registered ?? true }
  for (const name of [...TEXT_FIELDS, ...DATE_FIELDS]) form[name] = resident?.[name] ?? ''
  return form
}

function body(form) {
  const result = { full_name: form.full_name.trim(), is_registered: form.is_registered }
  for (const name of [...TEXT_FIELDS, ...DATE_FIELDS]) {
    const value = String(form[name]).trim()
    result[name] = value === '' ? null : value
  }
  return result
}

export default function ResidentDialog({ accountId, resident, onSaved, onClose }) {
  const [form, setForm] = useState(() => startForm(resident))
  const set = (name) => (event) => setForm({ ...form, [name]: event.target.value })
  const editing = Boolean(resident)

  function submit() {
    return editing
      ? api.editResident(accountId, resident.resident_id, body(form))
      : api.addResident(accountId, body(form))
  }

  const text = (name, label, width = 'm') => (
    <Field label={label} width={width}>
      <input className="field__input" value={form[name]} maxLength={255} onChange={set(name)} />
    </Field>
  )
  const day = (name, label) => (
    <Field label={label} width="s">
      <input className="field__input" type="date" value={form[name]} onChange={set(name)} />
    </Field>
  )

  return (
    <FormDialog
      title={editing ? 'Поправить проживающего' : 'Внести проживающего'}
      submitLabel={editing ? 'Сохранить' : 'Внести проживающего'}
      canSubmit={form.full_name.trim().length >= 2}
      wide
      onSubmit={submit}
      onSaved={onSaved}
      onClose={onClose}
    >
      <div className="row">
        <Field label="Фамилия, имя, отчество" width="l">
          <input
            className="field__input"
            value={form.full_name}
            maxLength={256}
            onChange={set('full_name')}
          />
        </Field>
        {day('birth_date', 'Дата рождения')}
      </div>
      <div className="row">
        {text('birth_place', 'Место рождения', 'l')}
        {text('citizenship', 'Гражданство', 's')}
      </div>
      <div className="row">
        {day('arrived_on', 'Дата прибытия')}
        {text('arrived_from', 'Откуда прибыл')}
        {day('left_on', 'Дата выбытия')}
        {text('left_to', 'Куда выбыл')}
      </div>
      <div className="row">
        {text('relation', 'Родство')}
        {text('purpose', 'Цель прибытия')}
        <Switch
          value={form.is_registered}
          onChange={(is_registered) => setForm({ ...form, is_registered })}
          options={REGISTERED}
        />
      </div>
    </FormDialog>
  )
}
